import { clsx } from 'clsx'

/** Cyber neon progress bar for preloader. */
export function LoadBar({
  fraction,
  label,
  count,
  className,
}: {
  fraction: number
  label?: string
  count?: number
  className?: string
}) {
  const pct = Math.round(Math.max(0, Math.min(1, fraction)) * 100)
  return (
    <div className={clsx('w-full', className)}>
      <div className="mb-2 flex items-end justify-between font-comic">
        <span className="text-xl uppercase tracking-wide text-white">{label ?? 'PRELOADING FEED…'}</span>
        <span className="text-2xl neon-pink">{pct}%</span>
      </div>
      <div className="h-2.5 w-full overflow-hidden rounded-full border border-edge bg-[#111] shadow-inner">
        <div
          className="h-full rounded-r-full bg-gradient-to-r from-pow via-kapow to-pow transition-[width] duration-200 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      {typeof count === 'number' ? (
        <div className="mt-1 text-right text-sm text-muted">{count} loaded</div>
      ) : null}
    </div>
  )
}
